export default "__VITE_ASSET__DjXD_mW$__"